import { FeatureFlags } from 'typings/enums';

export const defaultFlagSettings = {
    [FeatureFlags.ShowPayHistory]: true,
    [FeatureFlags.ShowUnificationTabs]: true,
    [FeatureFlags.JobCollabOnly]: false,
    [FeatureFlags.MobxCycleSettings]: true,
    [FeatureFlags.TeamDown]: false,
    [FeatureFlags.ShowDataSummary]: false,
    [FeatureFlags.ShowDataErrorBanner]: false,
    [FeatureFlags.ShowContactForm]: false,
    [FeatureFlags.ShowCaseDeflection]: false,
    [FeatureFlags.EmployeesPerPage]: 50,
    [FeatureFlags.ShowHideIneligibleEmployees]: false,
    [FeatureFlags.ShowCompMemo]: false,
    [FeatureFlags.TeamPayJobsList]: false
};

class FeatureFlagHelper {
    featureFlagSettings: {[key in FeatureFlags]: boolean|number};

    constructor(flags?: {[key in FeatureFlags]: boolean|number}) {
        this.featureFlagSettings = flags || defaultFlagSettings;
    }
}

export { FeatureFlagHelper };
export default FeatureFlagHelper;